//frontend/src/hooks/useHeadway.js

import { useRegion } from '../contexts/RegionContext';
import { usePolledResource } from './usePolledResource';

export function useExpectedArrivals(routeId, options = {}) {
  const { adapter } = useRegion();
  const { enabled = true, refetchInterval = 30000 } = options;
  const active = enabled && Boolean(routeId);

  return usePolledResource(
    () => adapter.fetchExpectedArrivals(routeId),
    [routeId, active, refetchInterval, adapter],
    { enabled: active, refetchInterval, initialData: [] }
  );
}